<template>
  <div class="container mt-6">
    <generic-table
      ref="datatable"
      :title="$t('system log')"
      :columns="columns"
      :column_search="true"
      :page_length="100"
      resource_url="/system/log/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="start_live_monitoring"
        >
          <span class="icon"><i class="fa fa-eye"></i></span>
          <span>{{ $t("live system monitor") }}</span>
        </button>
        <button
          class="button is-secondary is-rounded"
          @click="empty_system_log"
        >
          <span class="icon"><i class="fa fa-trash"></i></span>
          <span>{{ $t("empty system log") }}</span>
        </button>
      </template>
    </generic-table>
    <log-modal ref="log_modal" />
    <live-monitoring-modal ref="live_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  confirm_deletion_dialog,
  del,
  error_message,
  generate_datatables_buttons,
  format_date,
  format_time,
} from "@/utils";
import LogModal from "./log_modal/Index.vue";
import LiveMonitoringModal from "./live_monitoring_modal/Index.vue";
// import { truncate } from "lodash";

export default {
  name: "SystemLog",
  components: { GenericTable, LogModal, LiveMonitoringModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          width: "17%",
          searchable: false,
          name: "create_date",
          data: (row) => {
            return (
              `${format_date(row.create_date)} ${format_time(
                row.create_date
              )}` || ""
            );
          },
        },
        {
          title: v.$t("user"),
          width: "10%",
          searchable: false,
          data: (row) => {
            return row.create_user.username || "";
          },
        },
        // {
        //   title: v.$t("resource"),
        //   name: "path",
        //   width: "25%",
        //   // searchable: false,
        //   data: (row) => {
        //     return `${row.method} ${row.path}` || "";
        //   },
        // },
        {
          title: v.$t("data"),
          width: "60%",
          searchable: false,
          data: (row) => {
            return `<ul>
                      <li><b>${row.method} ${row.path}</b></li>
                      <li>${v.$t("request")}: ${row.request_data}</li>
                      <li>${v.$t("response")}: ${row.response_data}</li>
                    </ul>`;
          },
        },
        // {
        //   title: v.$t("response data"),
        //   width: "30%",
        //   searchable: false,
        //   data: (row) => {
        //     return row.response_data || "";
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete system log?"),
                    v,
                    () => {
                      del("/system/log", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  v.$refs.log_modal.show_modal(uuid);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_time,
    create() {
      let v = this;
      v.$refs.enterprise_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    empty_system_log() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to empty system log?"),
        v,
        () => {
          del("/system/log/empty")
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    start_live_monitoring() {
      let v = this;
      v.$refs.live_modal.show_modal();
    },
  },
  mounted() {
    // let v = this;
    // v.init();
  },
};
</script>

<style></style>
